// client/src/api/ApiFeatureFlags.js
import flex from './FlexFetch'

const endpoint = '/api/1.0/config/'

async function getAll() {
  const response = await flex.flexFetch(`${endpoint}getFeatureFlags`)
  return await flex.handleResponse(response)
}

async function update(updates) {
  const response = await flex.flexFetch(`${endpoint}updateFeatureFlags`, {
    method: 'POST',
    body: JSON.stringify({ updates }),
  })
  return await flex.handleResponse(response)
}

const ApiFeatureFlags = {
  getAll,
  update,
}

export default ApiFeatureFlags
